import { BatchRule } from "./batch-rule";
import { Subject } from "rxjs";
import { TenantStorageOption } from "./tenant-storage-option";

export abstract class BatchRulesRepository {
  ruleAdded: Subject<BatchRule>;
  ruleUpdated: Subject<BatchRule>;

  getRules: () => Promise<BatchRule[]>;

  addRule: (rule: BatchRule) => Promise<number>;

  updateRule: (
    rule: BatchRule,
    detachRelatedSubtitles?: boolean,
  ) => Promise<void>;

  deleteRules: (rules: BatchRule[]) => Promise<any>;

  check: (
    path: string,
    storageOption: TenantStorageOption,
    selectedRuleIds: number[],
  ) => Promise<CheckResultEntry[]>;

  go: (
    path: string,
    storageOption: TenantStorageOption,
    deadlineOffsetHours: number,
    existingMediaHandlingPolicy: EMediaExistingHandling,
    selectedRuleIds: number[],
  ) => Promise<void>;
}

export class CheckResultEntry {
  constructor(
    public fileName: string,
    public bucketPath: string,
    public status: string,
    public ruleName: string,
    public parentMediaTenantUniqueId: string,
    public parentMediaId: number,
    public isAssociated: boolean,
    public existingMediaId?: number,
  ) {}
}
export enum EMediaExistingHandling {
  Skip,
  ReplaceFiles,
}
